import StateCommodityName, { StateCommodityHeader } from '../components/StateCommodityName';
import LookupUrl from '../components/LookupUrl';
const columns = [
    { accessorKey: 'stateName', header: StateCommodityHeader, enableSorting: false,
        meta: { relatedFields: ['stateId', 'commodityId', 'commodityName'] }, cell: ({ row }) => <StateCommodityName record={row.original} /> },
    { accessorKey: 'utilityCommissionName', header: 'Commission Name', enableSorting: false, cell: ({ getValue }) => getValue() || '—' },
    { accessorKey: 'utilityCommissionShortName', header: 'Short Name', enableSorting: false, cell: ({ getValue }) => getValue() || '—' },
    { accessorKey: 'utilityCommissionURL', header: 'Commission URL', enableSorting: false, cell: ({ getValue }) => <LookupUrl value={getValue()} label="Commission website" /> },
    { accessorKey: 'utilityCommissionCommodityServiceURL', header: 'Commodity Service URL', enableSorting: false, cell: ({ getValue }) => <LookupUrl value={getValue()} label="Commodity services" /> },
];

export default columns;
